import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Azi',
    asap: 'Cât mai curând',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Numărul camerei',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Numărul mesei',
  },
};
